export default __webpack_public_path__ + "static/CamionGratte-28f66bd4cdfc6b935685183131af52d2.svg";